import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../core/services/alert.service';
import { Member } from '../core/models/member.model';
import { CommonService } from '../core/services/common.service';
import { PushService } from '../core/services/push.service';
import { DbService } from '../core/services/db.service';
import { Notification } from '../core/models/notification.model';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.scss'],
})
export class PushModalComponent {
  content = ''
  members: Member[];
  constructor(private db: DbService, private modalService: NgbModal, private pushService: PushService, private commonService: CommonService, private alertService: AlertService) { }

  modalClose() {
    this.modalService.dismissAll();
  }
  //푸시 보내기
  sendPush() {
    // 필수값 입력 누락 있는 경우
    if (!this.content) {
      this.alertService.errormsg('내용을 입력해주세요.');
      return;
    }
    // 필수값 모두 입력 시
    this.alertService.successConfirm('입력하신 내용으로 전송 하시겠습니까?', '전송').then(async ok => {
      if (ok) {
        await Promise.all(
          this.members.map(async (member) => {
            const user = await this.db.toDoc$(`members/${member.uuid}`)
            const id = this.commonService.generateFilename()
            const updateInfo: Notification = {
              id,
              uuid: member.uuid,
              dateCreated: new Date().toISOString(),
              readSwitch: false,
              title: '우리푸드',
              content: this.content,
              url: `/notification-detail?id=`,
              detailId: id
            };
            await this.db.updateAt(`notifications/${updateInfo.id}`, updateInfo);
            if (user.marketingSwitch) {
              // TODO 푸시 셋팅 후
              await this.pushService.sendPush(member.pushId, this.content, {
                url: '/notification'
              }, '우리푸드')
            }
          })
        );
        this.alertService.swalToast('알림이 전송되었습니다.');
        this.modalService.dismissAll();
      }
    });
  }
}
